import { render, staticRenderFns } from "./ProjectBankDetails.vue?vue&type=template&id=2670165a"
import script from "./ProjectBankDetails.vue?vue&type=script&lang=js"
export * from "./ProjectBankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports